
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moving-box-shipping",
      function () {
        return require("private-next-pages/moving-box-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moving-box-shipping"])
      });
    }
  